module.exports = __webpack_public_path__ + "static/media/41.7ff7c904.mp3";